import { render } from "./ServerManagement.vue?vue&type=template&id=1e5e61f5&scoped=true"
import script from "./ServerManagement.vue?vue&type=script&lang=js"
export * from "./ServerManagement.vue?vue&type=script&lang=js"

import "./ServerManagement.vue?vue&type=style&index=0&id=1e5e61f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5e61f5"]])

export default __exports__